import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57849eac")

_pushScopeId("data-v-57849eac")
const _hoisted_1 = { class: "specifications" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h3", { class: "specifications__title" }, "권장 브라우저"),
  /*#__PURE__*/_createVNode("ul", { class: "specifications-list" }, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("figure", null, [
        /*#__PURE__*/_createVNode("img", {
          src: "/images/new/safari.png",
          alt: "safari"
        })
      ]),
      /*#__PURE__*/_createVNode("span", null, "iPhone/MAC")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("figure", null, [
        /*#__PURE__*/_createVNode("img", {
          src: "/images/new/chrome.png",
          alt: "chrome"
        })
      ]),
      /*#__PURE__*/_createVNode("span", null, "Android/Windows")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})